import { useCallback, useState } from "react";

const useAsyncError = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [_, setError] = useState();
	return useCallback(
		e => {
			setError(() => {
				throw e;
			});
		},
		[setError]
	);
};

export { useAsyncError };